import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";

export default function MapBandsLegendCircle({ color }) {
  return (
    <Box
      sx={{
        width: "1.5rem",
        height: "1.5rem",
        borderRadius: "50%",
        backgroundColor: color,
        borderColor: grey[500],
        borderWidth: "1px",
        borderStyle: "solid",
      }}
    />
  );
}
